export enum FlightType {
  ONE_WAY = "oneway",
  ROUND_TRIP = "roundtrip",
  MULTI_CITY = "multicity",
}

export const FlightTypeCodeMap = {
  roundtrip: "ROUND_TRIP",
  oneway: "ONE_WAY",
  multicity: "MULTIPLE_DESTINATION",
  default: "ROUND_TRIP",
};
